interface Opts {
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  showLessThanSymbol?: boolean;
}

export default function formatNumber(
  value: number | null | undefined,
  {
    locale = 'en-GB',
    minimumFractionDigits = undefined,
    maximumFractionDigits = 2,
    showLessThanSymbol = false,
  }: Opts = {},
) {
  if (!value && value !== 0) {
    return '';
  }

  if (minimumFractionDigits === null && maximumFractionDigits === 2 && showLessThanSymbol === false) {
    if (value > 0 && value < 0.01) {
      return value;
    }
  }
  const formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);

  if (
    showLessThanSymbol &&
    value !== 0 &&
    (formattedNumber === '0' || formattedNumber === `0.${'0'.repeat(maximumFractionDigits)}`)
  ) {
    // This is so that small numbers do not get incorrectly displayed as 0
    // e.g. if maximumFractionDigits = 2 (i.e. 2dp), and the formatted number is 0.004, then we want to output <0.01 rather than 0
    const formattedNumberFraction = new Intl.NumberFormat(locale, { maximumFractionDigits }).format(
      1 / 10 ** maximumFractionDigits,
    );

    return `<${formattedNumberFraction.toString()}`;
  }

  const extra = formattedNumber.split('.');
  if (maximumFractionDigits === 2) {
    if (extra.length > 1 && extra[1].length === 1) {
      return `${formattedNumber}0`;
    }
  }

  return formattedNumber;
}
